import { render, staticRenderFns } from "./Thrk.vue?vue&type=template&id=22cebc2e&scoped=true&"
import script from "./Thrk.vue?vue&type=script&lang=js&"
export * from "./Thrk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cebc2e",
  null
  
)

export default component.exports